import { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import { CardHeader } from "reactstrap/lib"

import { IProjectFollowership } from "@api/schema"
import Icon from "@components/common/Icon"
import { idFromIModelOrIRI, uriHashMatchesId } from "@services/util"

import FollowershipCard from "./FollowershipCard"

interface IProps {
  cardTitle: string
  followerships: IProjectFollowership[]
  listCardHashId: string
}

/**
 * This component shows a collapsable card containing all given followerships.
 */
const FollowershipsCard: React.FC<IProps> = (props: IProps) => {

  const initiallyOpen = uriHashMatchesId(props.listCardHashId)
  const [followershipsOpen, setFollowershipsOpen] = useState(initiallyOpen /* && followerships.length */)
  const toggleFollowerships = () => { setFollowershipsOpen(!followershipsOpen) }

  return <Card className="collapsable-card" data-testid="ProjectFollowershipsCard">
    <CardHeader
      id="toggler-followerships"
      onClick={toggleFollowerships}
      aria-expanded={followershipsOpen ? "true" : "false"}
    >
      <div className="title-section">
        <h2>{props.cardTitle}</h2>
      </div>
      <span className={"chevron-right" + (followershipsOpen ? " chevron-right--toggled" : "")}><Icon name="chevron-right" size={42} /></span>
    </CardHeader>

    <Collapse id={props.listCardHashId} isOpen={followershipsOpen}>
      <CardBody className="followership-card-layout">
        {props.followerships.map(followership =>
          <FollowershipCard
            key={"follower-project-" + idFromIModelOrIRI(followership.project).toString()}
            projectFollowership={followership}
          />
        )}
      </CardBody>
    </Collapse>
  </Card>
}

export default FollowershipsCard
